import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { ConfirmingReportItemListTemplate } from "themes/application/confirming-report/pages";
import { ConfirmingReportItemListViewStore } from "application/confirming-report/stores";

@setCurrentView(rootStore => new ConfirmingReportItemListViewStore(rootStore), "confirmingReportItemListViewStore")
@observer
class ConfirmingReportItemList extends React.Component {
    render() {
        return <ConfirmingReportItemListTemplate {...this.props} />;
    }
}

export default ConfirmingReportItemList;